import { Platform } from 'react-native';

/**
 * Web-only CSS transition shim for hover effects.
 *
 * React Native Web compiles standard `transitionProperty` /
 * `transitionDuration` style props into real CSS transitions, so
 * hover-state style changes animate smoothly instead of snapping.
 * On native we strip the props out (RN's native runtime doesn't
 * understand them and would log warnings).
 *
 * Apply to any Pressable whose style function reads `hovered`:
 *
 *   style={({ hovered }) => [styles.base, webTransition, hovered && styles.hover]}
 *
 * The properties listed in `transitionProperty` are the ones we
 * actually animate across the app — bg color, border color, opacity,
 * and (sparingly) transform. Keeping the list explicit means an
 * accidentally-changing property like `width` doesn't get an
 * unexpected animation.
 *
 * 180ms with ease-out is the sweet spot for "feels responsive but
 * not snappy" — short enough to read as immediate, long enough that
 * the eye registers the easing. Match Material's spec for short
 * exit transitions.
 */
export const webTransition =
  Platform.OS === 'web'
    ? ({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        transitionProperty: 'background-color, border-color, opacity, transform, box-shadow',
        transitionDuration: '180ms',
        transitionTimingFunction: 'ease-out',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any)
    : {};
